/** A null state is the row that applies to every state without its own. */
export function stateLabel(state: string | null | undefined) {
  return state ?? "All other states";
}
